(() => {
  const root = document.documentElement;
  root.classList.add('nv4-theme');

  const reveal = (scope = document) => {
    const items = [...scope.querySelectorAll('[data-nv4-reveal]:not(.is-observed)')];
    if (!items.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    items.forEach((item) => {
      item.classList.add('is-observed');
      observer.observe(item);
    });
  };

  const setHeaderState = () => {
    const header = document.querySelector('.section-header');
    if (header) header.classList.toggle('nv4-is-scrolled', window.scrollY > 24);
  };

  reveal();
  setHeaderState();
  window.addEventListener('scroll', setHeaderState, { passive: true });
  document.addEventListener('shopify:section:load', (event) => reveal(event.target));
})();
